module.exports = {
  IS_DEV: process.env.VUE_APP_IS_DEV === "true",
  API_URL: process.env.VUE_APP_API_URL,
  RECAPTCHA_V3_KEY: process.env.VUE_APP_RECAPTCHA_V3_KEY,
};
